'use strict';

import { showInfoModal } from "./modals";

(function (axios) {
  $(document).ready(function () {
    const $step1 = $('.js-callback__form_1'),
      $step2 = $('.js-callback__form_2'),

      $name = $('.js-callback__name'),
      $phone = $('.js-callback__phone'),
      $email = $('.js-callback__email');

    $step2.hide();
    $step1.show();

    $name.change(function () {
      const value = $(this).val();
      $name.val(value);
    })
    $phone.change(function () {
      const value = $(this).val();
      $phone.val(value);
    })
    var maskList = $.masksSort($.masksLoad(document.phoneCodesMasksPath), ['#'], /[0-9]|#/, "mask");
    var maskOpts = {
      inputmask: {
        definitions: {
          '#': {
            validator: "[0-9]",
            cardinality: 1
          }
        },
        clearIncomplete: true,
        showMaskOnHover: false,
        autoUnmask: true
      },
      match: /[0-9]/,
      replace: '#',
      list: maskList,
      listKey: "mask",
    };
    $phone.inputmasks(maskOpts);

    var callback_id = null;

    $step1.validate({
      rules: {
        phone: {
          required: true
        },
      }
    })
    let processing = false;
    $step1.submit(function (e) {
      e.preventDefault();
      if (processing) { return false; }
      $('.error-captcha').remove();
      if (!$step1.valid()) { return false; }

      try {
        if (captchaCallback !== undefined) {
          var token = grecaptcha.getResponse(captchaCallback);
          if (token != '') {
            // captcha pass
          } else {
            $('.checking-data').hide();
            $('#captcha_callback').after('<div class="error-captcha">Пожалуйста, отметьте что вы не робот. Спасибо</div>');
            return false;
          }
        }
      } catch {}

      processing = true;
      axios.post($step1.attr('action'), {
        phone: $phone.val(),
        name: $name.val(),
        'g-recaptcha-response': token,
      }).then(function (response) {
        if (response.status === 200) {
            if (response.data && response.data.error) {
                alert('Ошибка выполнения запроса');
                processing = false;
                return false;
            } else {
                callback_id = response.data.callback_id;
                console.log(response.data, response.data.callback_id);
            }

          $step1.hide();
          $step2.show();
        }
        processing = false;
      })
    })

    $step2.validate({
      rules: {
        phone: {
          required: true
        },
        email: {
          email: true,
          required: true
        },
      }
    })
    $step2.submit(function (e) {
      e.preventDefault();
      if (processing) { return false; }
      if (!$step2.valid()) { return false; }

      processing = true;
      axios.post($step2.attr('action'), {
        phone: $phone.val(),
        name: $name.val(),
        email: $email.val(),
        callback_id: callback_id,
      }).then(function (response) {
        if (response.status === 200) {
          callback_id = null;
            console.log('cbid null')

          if (response.data && response.data.error) {
            alert('Запрос не отправлен');
          } else {
            showInfoModal("Заявка на обратную связь успешно отправлена")
          }

          $step1.show();
          $step2.hide();
          try {
            if (captchaCallback !== undefined) {
              grecaptcha.reset(captchaCallback);
            }
          } catch {}
          $phone.val(''),
            $name.val(''),
            $email.val('')
        }
        processing = false;
      })
    })

  })
})(window.axios)
